import { useUser } from "../../context/UserContext";

const OfflineIndicator = () => {
    const { isOffline } = useUser();

    if (isOffline) {
        return (
            <div className="pointer-events-none fixed top-4 right-0 left-0 z-50 flex justify-center">
                <div className="flex items-center gap-1 rounded-lg bg-black px-2 py-1 text-xs text-white">
                    <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5.5 10H5.505M3.75 8.2145C4.21732 7.75643 4.84562 7.49986 5.5 7.49986C6.15438 7.49986 6.78268 7.75643 7.25 8.2145M2 6.4295C2.70901 5.73445 3.6089 5.26623 4.585 5.0845M9 6.4295C8.69894 6.13438 8.36177 5.87851 7.9965 5.668M0.5 4.41C1.1183 3.85704 1.82404 3.41048 2.5885 3.0885M10.5 4.41C9.73736 3.72791 8.84322 3.20907 7.8726 2.88542C6.90197 2.56176 5.87539 2.44013 4.856 2.528M0.5 1L10.5 11"
                            stroke="#A8A29E"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <span className="font-medium">You're offline</span> Attempting to reconnect.
                </div>
            </div>
        );
    }
};

export default OfflineIndicator;
